var _defs, _rect, _path, _circle, _clipPath, _path2, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2100 -1470 4200 2940",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    fillRule: "evenodd",
    d: "M-31.5 0h33a30 30 0 0030-30v-10a30 30 0 00-30-30h-33zm13-13h19a19 19 0 0019-19v-6a19 19 0 00-19-19h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M-15.75-22C-15.75-15-9-11.5 1-11.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25C-30.5-71-6-70 3-70s26 4 25.75 21.25H13.5c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-.25 11.75 46.25 4 46.25 28.75C31.5-3.5 13.5 0 0 0c-11.5 0-31.55-4.5-31.5-22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11H25v-12h-51.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M-31.5 0h12v-48l14 48h11l14-48V0h12v-70H14L0-22l-14-48h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    fillRule: "evenodd",
    d: "M0 0a31.5 35 0 000-70A31.5 35 0 000 0m0-13a18.5 22 0 000-44 18.5 22 0 000 44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    fillRule: "evenodd",
    d: "M-31.5 0h13v-26h28a22 22 0 000-44h-40zm13-39h27a9 9 0 000-18h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    transform: "translate(-31.5)",
    d: "M0 0h63v-13H12v-18h40v-12H12v-14h48v-13H0z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "q",
    xlinkHref: "#a",
    transform: "scale(15)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "s",
    xlinkHref: "#a",
    transform: "scale(10.5)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "r",
    xlinkHref: "#a",
    transform: "scale(21)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "o",
    xlinkHref: "#a",
    transform: "scale(31.5)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "p",
    xlinkHref: "#a",
    transform: "scale(26.25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    transform: "rotate(18 0 -1)",
    d: "M0-1v1h.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(216)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.5 0v-70h63V0zM0-47v12h31.5v-12z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    clipPath: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5-35h26.5v10H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5-35h10V0h-10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0c0-10 0-32-15-32H-6c22 0 22 22 22 32"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: "-50%",
    x: "-50%",
    height: "100%",
    fill: "#009b3a",
    width: "100%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1743 0L0 1113 1743 0 0-1113z",
    fill: "#fedf00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 735,
    fill: "#002776"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 735
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-2205 1470a1785 1785 0 013570 0h-105a1680 1680 0 10-3360 0z",
    clipPath: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420 1470)",
    fill: "#009b3a"
  }, /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#d",
    transform: "rotate(-7)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#h",
    transform: "rotate(-4)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#i",
    transform: "rotate(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#j",
    transform: "rotate(2)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#k",
    transform: "rotate(5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#l",
    transform: "rotate(9.75)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#f",
    transform: "rotate(14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#h",
    transform: "rotate(17.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#d",
    transform: "rotate(20.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#m",
    transform: "rotate(23.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#h",
    transform: "rotate(26.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#j",
    transform: "rotate(29.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#n",
    transform: "rotate(32.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#n",
    transform: "rotate(35.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#d",
    transform: "rotate(38.5)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    y: -132,
    x: -600,
    xlinkHref: "#o"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    y: 177,
    x: -535,
    xlinkHref: "#o"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    y: 243,
    x: -625,
    xlinkHref: "#p"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    y: 132,
    x: -463,
    xlinkHref: "#q"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    y: 250,
    x: -382,
    xlinkHref: "#p"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    y: 323,
    x: -404,
    xlinkHref: "#r"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    y: -228,
    x: 228,
    xlinkHref: "#o"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    y: 258,
    x: 515,
    xlinkHref: "#o"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    y: 265,
    x: 617,
    xlinkHref: "#r"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    y: 323,
    x: 545,
    xlinkHref: "#p"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    y: 477,
    x: 368,
    xlinkHref: "#p"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    y: 551,
    x: 367,
    xlinkHref: "#r"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    y: 419,
    x: 441,
    xlinkHref: "#r"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    y: 382,
    x: 500,
    xlinkHref: "#p"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    y: 405,
    x: 365,
    xlinkHref: "#r"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    y: 30,
    x: -280,
    xlinkHref: "#p"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    y: -37,
    x: 200,
    xlinkHref: "#r"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    y: 330,
    xlinkHref: "#o"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    y: 184,
    x: 85,
    xlinkHref: "#p"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    y: 118,
    xlinkHref: "#p"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    y: 184,
    x: -74,
    xlinkHref: "#r"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    y: 235,
    x: -37,
    xlinkHref: "#q"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    y: 495,
    x: 220,
    xlinkHref: "#p"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    y: 430,
    x: 283,
    xlinkHref: "#r"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    y: 412,
    x: 162,
    xlinkHref: "#r"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    y: 390,
    x: -295,
    xlinkHref: "#o"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    y: 575,
    xlinkHref: "#s"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/br.e01c0bc82c40422195529f6be2fcb69d.svg";
export { ForwardRef as ReactComponent };